import { render, staticRenderFns } from "./ManufacturerEditForm.vue?vue&type=template&id=57cb9eb1"
import script from "./ManufacturerEditForm.vue?vue&type=script&lang=js"
export * from "./ManufacturerEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports